import { useQuery } from '@tanstack/react-query';
import { fetch } from '../fetch';
import { schemas } from '@convergence/client';

export const useAnalysisSchemaQuery = (
  id: number | undefined,
  version: number | undefined
) => {
  const query = useQuery({
    enabled: id !== undefined && version !== undefined,
    queryKey: ['analysisSchema', id, version],
    queryFn: async () => {
      return fetch(
        `/analysis/schema/${id}/versions?version=${version}`,
        { method: 'GET' },
        schemas.AnalysisSchemaVersionsDto
      );
    },
    retry: false
  });

  return query;
};
